import { render, staticRenderFns } from "./LogoDev.vue?vue&type=template&id=15b64464&"
import script from "./LogoDev.vue?vue&type=script&lang=js&"
export * from "./LogoDev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports